module Client.Components.Clickable

open Browser.Types
open Fable.React.Props

let onClick (f: MouseEvent -> Unit) =
    OnClick(fun event ->
        event.preventDefault ()

        f event
    )